// extracted by mini-css-extract-plugin
export default {"container":"QuizToast-module__container__B7uJ1 dimensions__level-three__Dq5Hr"};